var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	69852: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_core_fesm2022_untracked-BKcld_ew_mjs"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.2.18",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",
	},
	48310: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_common_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.2.18",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",
	},
	13258: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_rxjs_dist_esm5_internal_operators_auditTime_js-node_modules_rxjs_dist_es-064601"), __webpack_require__.e("node_modules_rxjs_dist_esm5_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs */ 61264))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.5.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",
	},
	28822: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_rxjs_dist_esm5_internal_operators_auditTime_js-node_modules_rxjs_dist_es-064601"), __webpack_require__.e("node_modules_rxjs_dist_esm5_operators_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 59518))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.5.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",
	},
	81170: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.2.18",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",
	},
	92232: {
		fallback: () => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 52867))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.2.18",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",
	},
	37602: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_http_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.2.18",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",
	},
	56207: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022_platform-browser_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.2.18",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",
	},
	72290: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-node_modules_angular_router_fesm2022_router_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.2.18",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",
	},
	30908: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_forms_fesm2022_forms_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.2.18",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",
	},
	72701: {
		fallback: () => (__webpack_require__.e("node_modules_sweetalert2_dist_sweetalert2_all_js").then(() => (() => (__webpack_require__(/*! sweetalert2 */ 37581))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.4.29",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "sweetalert2",
	},
	44502: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_animations_angular_animations"), __webpack_require__.e("default-node_modules_ngx-toastr_fesm2020_ngx-toastr_mjs")]).then(() => (() => (__webpack_require__(/*! ngx-toastr */ 96371))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^14.2.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ngx-toastr",
	},
	77515: {
		fallback: () => (__webpack_require__.e("node_modules_uuid_dist_esm-browser_index_js").then(() => (() => (__webpack_require__(/*! uuid */ 33358))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^9.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "uuid",
	},
	42406: {
		fallback: () => (__webpack_require__.e("default-node_modules_ngx-currency_fesm2022_ngx-currency_mjs").then(() => (() => (__webpack_require__(/*! ngx-currency */ 7453))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^19.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ngx-currency",
	},
	89840: {
		fallback: () => (__webpack_require__.e("default-libs_data-access_src_index_ts").then(() => (() => (__webpack_require__(/*! @envytory-micro-apps/data-access */ 60007))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.5652",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@envytory-micro-apps/data-access",
	},
	80672: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_ng-bootstrap_ng-bootstrap_fesm2022_ng-bootstrap_mjs")]).then(() => (() => (__webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ 48418))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ng-bootstrap/ng-bootstrap",
	},
	80: {
		fallback: () => (__webpack_require__.e("node_modules_html2canvas_dist_html2canvas_js").then(() => (() => (__webpack_require__(/*! html2canvas */ 60822))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.4.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "html2canvas",
	},
	34016: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_forms_angular_forms"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-webpack_sharing_consume_default_sweetalert2_sweetalert2"), __webpack_require__.e("default-webpack_sharing_consume_default_ngx-toastr_ngx-toastr-webpack_sharing_consume_default-c82c08"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_animations_angular_animations"), __webpack_require__.e("default-webpack_sharing_consume_default_envytory-micro-apps_data-access_envytory-micro-apps_d-7c2c1b"), __webpack_require__.e("default-webpack_sharing_consume_default_fortawesome_free-solid-svg-icons_fortawesome_free-sol-ab539f"), __webpack_require__.e("default-webpack_sharing_consume_default_ngx-loading-bar_core_ngx-loading-bar_core"), __webpack_require__.e("default-webpack_sharing_consume_default_lodash_lodash"), __webpack_require__.e("default-webpack_sharing_consume_default_dayjs_dayjs"), __webpack_require__.e("default-libs_shared_common_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @envytory-micro-apps/shared/common */ 81993))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.5652",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@envytory-micro-apps/shared/common",
	},
	59275: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_animations_angular_animations"), __webpack_require__.e("default-node_modules_ngx-chips_fesm2020_ngx-chips_mjs")]).then(() => (() => (__webpack_require__(/*! ngx-chips */ 37419))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ngx-chips",
	},
	18435: {
		fallback: () => (__webpack_require__.e("default-node_modules_ngx-print_fesm2022_ngx-print_mjs").then(() => (() => (__webpack_require__(/*! ngx-print */ 33133))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.5.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ngx-print",
	},
	13948: {
		fallback: () => (__webpack_require__.e("node_modules_jspdf_dist_jspdf_es_min_js").then(() => (() => (__webpack_require__(/*! jspdf */ 2752))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.5.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "jspdf",
	},
	34824: {
		fallback: () => (__webpack_require__.e("default-node_modules_angular_animations_fesm2022_animations_mjs").then(() => (() => (__webpack_require__(/*! @angular/animations */ 47172))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.2.18",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations",
	},
	97324: {
		fallback: () => (__webpack_require__.e("node_modules_moment_moment_js").then(() => (() => (__webpack_require__(/*! moment */ 39545))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.29.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "moment",
	},
	83079: {
		fallback: () => (__webpack_require__.e("node_modules_fortawesome_free-solid-svg-icons_index_mjs").then(() => (() => (__webpack_require__(/*! @fortawesome/free-solid-svg-icons */ 29634))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "6.7.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@fortawesome/free-solid-svg-icons",
	},
	79927: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_ngx-loading-bar_core_fesm2020_ngx-loading-bar-core_mjs")]).then(() => (() => (__webpack_require__(/*! @ngx-loading-bar/core */ 65545))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.0.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngx-loading-bar/core",
	},
	97250: {
		fallback: () => (__webpack_require__.e("node_modules_lodash_lodash_js").then(() => (() => (__webpack_require__(/*! lodash */ 46227))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.17.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "lodash",
	},
	44803: {
		fallback: () => (__webpack_require__.e("node_modules_dayjs_dayjs_min_js").then(() => (() => (__webpack_require__(/*! dayjs */ 49645))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.11.7",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "dayjs",
	},
	12254: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_angular_cdk_fesm2022_portal-directives-Bw5woq8I_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_overlay_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 81570))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.2.18",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/overlay",
	},
	574: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_angular_cdk_fesm2022_portal-directives-Bw5woq8I_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.2.18",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/portal",
	},
	60517: {
		fallback: () => (__webpack_require__.e("default-node_modules_fortawesome_angular-fontawesome_fesm2022_angular-fontawesome_mjs").then(() => (() => (__webpack_require__(/*! @fortawesome/angular-fontawesome */ 17518))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@fortawesome/angular-fontawesome",
	},
	22230: {
		fallback: () => (__webpack_require__.e("default-node_modules_angular_google-maps_fesm2022_google-maps_mjs").then(() => (() => (__webpack_require__(/*! @angular/google-maps */ 33428))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.2.18",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/google-maps",
	},
	51186: {
		fallback: () => (__webpack_require__.e("default-node_modules_ng-select_ng-select_fesm2022_ng-select-ng-select_mjs").then(() => (() => (__webpack_require__(/*! @ng-select/ng-select */ 62223))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^13.9.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ng-select/ng-select",
	},
	13231: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_swimlane_ngx-datatable_fesm2020_swimlane-ngx-datatable_mjs")]).then(() => (() => (__webpack_require__(/*! @swimlane/ngx-datatable */ 13841))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@swimlane/ngx-datatable",
	},
	46676: {
		fallback: () => (__webpack_require__.e("default-node_modules_ngx-translate_core_fesm2022_ngx-translate-core_mjs").then(() => (() => (__webpack_require__(/*! @ngx-translate/core */ 48503))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.0.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngx-translate/core",
	},
	74714: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_ag-charts-community_dist_package_main_esm_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! ag-charts-angular */ 88669))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "13.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ag-charts-angular",
	},
	26537: {
		fallback: () => (__webpack_require__.e("default-node_modules_ngx-webcam_fesm2020_ngx-webcam_mjs").then(() => (() => (__webpack_require__(/*! ngx-webcam */ 93491))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^0.4.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ngx-webcam",
	},
	74027: {
		fallback: () => (__webpack_require__.e("default-node_modules_ngx-daterangepicker-bootstrap_fesm2020_ngx-daterangepicker-bootstrap_mjs").then(() => (() => (__webpack_require__(/*! ngx-daterangepicker-bootstrap */ 83565))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^14.5.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ngx-daterangepicker-bootstrap",
	},
	1743: {
		fallback: () => (__webpack_require__.e("default-node_modules_ngx-gravatar_fesm2020_ngx-gravatar_mjs").then(() => (() => (__webpack_require__(/*! ngx-gravatar */ 97775))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^13.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ngx-gravatar",
	},
	37789: {
		fallback: () => (__webpack_require__.e("default-node_modules_ngx-quill_fesm2020_ngx-quill_mjs").then(() => (() => (__webpack_require__(/*! ngx-quill */ 16571))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ngx-quill",
	},
	10834: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_ag-grid-community_ag-grid-community"), __webpack_require__.e("default-node_modules_ag-grid-angular_fesm2022_ag-grid-angular_mjs")]).then(() => (() => (__webpack_require__(/*! ag-grid-angular */ 27291))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "35.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ag-grid-angular",
	},
	7026: {
		fallback: () => (__webpack_require__.e("default-node_modules_sweetalert2_ngx-sweetalert2_fesm2022_sweetalert2-ngx-sweetalert2_mjs").then(() => (() => (__webpack_require__(/*! @sweetalert2/ngx-sweetalert2 */ 94483))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@sweetalert2/ngx-sweetalert2",
	},
	8324: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @ngx-loading-bar/http-client */ 30845))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.0.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngx-loading-bar/http-client",
	},
	51453: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @ngx-loading-bar/router */ 52653))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.0.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngx-loading-bar/router",
	},
	3305: {
		fallback: () => (__webpack_require__.e("default-node_modules_nodro7_angular-mydatepicker_fesm2020_nodro7-angular-mydatepicker_mjs").then(() => (() => (__webpack_require__(/*! @nodro7/angular-mydatepicker */ 49057))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^0.12.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@nodro7/angular-mydatepicker",
	},
	28634: {
		fallback: () => (__webpack_require__.e("default-node_modules_bugsplat_angular-tree-component_fesm2020_bugsplat-angular-tree-component_mjs").then(() => (() => (__webpack_require__(/*! @bugsplat/angular-tree-component */ 63135))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^13.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@bugsplat/angular-tree-component",
	},
	36194: {
		fallback: () => (__webpack_require__.e("default-node_modules_ngx-treeview_fesm2015_ngx-treeview_js").then(() => (() => (__webpack_require__(/*! ngx-treeview */ 40135))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^10.0.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ngx-treeview",
	},
	56599: {
		fallback: () => (__webpack_require__.e("node_modules_angular2-uuid_index_js").then(() => (() => (__webpack_require__(/*! angular2-uuid */ 68671))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.1.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "angular2-uuid",
	},
	18920: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_ag-charts-community_dist_package_main_esm_mjs"), __webpack_require__.e("node_modules_ag-charts-enterprise_dist_package_main_esm_mjs")]).then(() => (() => (__webpack_require__(/*! ag-charts-enterprise */ 91791))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^13.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ag-charts-enterprise",
	},
	71530: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_ag-grid-community_ag-grid-community"), __webpack_require__.e("node_modules_ag-grid-enterprise_dist_package_main_esm_mjs")]).then(() => (() => (__webpack_require__(/*! ag-grid-enterprise */ 69834))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "35.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ag-grid-enterprise",
	},
	61369: {
		fallback: () => (__webpack_require__.e("node_modules_yaireo_tagify_dist_tagify_esm_js").then(() => (() => (__webpack_require__(/*! @yaireo/tagify */ 46059))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.9.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@yaireo/tagify",
	},
	42369: {
		fallback: () => (() => (__webpack_require__(/*! @microsoft/signalr */ 61389))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^8.0.7",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "@microsoft/signalr",
	},
	88724: {
		fallback: () => (__webpack_require__.e("default-node_modules_angular_core_fesm2022_rxjs-interop_mjs").then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "19.2.18",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",
	},
	11202: {
		fallback: () => (__webpack_require__.e("node_modules_ag-grid-community_dist_package_main_esm_mjs").then(() => (() => (__webpack_require__(/*! ag-grid-community */ 72176))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "35.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ag-grid-community",
	},
	12467: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! ngx-quill/config */ 67966))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ngx-quill/config",
	},
	48558: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_forms_angular_forms"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-webpack_sharing_consume_default_sweetalert2_sweetalert2"), __webpack_require__.e("default-webpack_sharing_consume_default_ngx-toastr_ngx-toastr-webpack_sharing_consume_default-c82c08"), __webpack_require__.e("default-webpack_sharing_consume_default_envytory-micro-apps_data-access_envytory-micro-apps_d-7c2c1b"), __webpack_require__.e("default-webpack_sharing_consume_default_html2canvas_html2canvas"), __webpack_require__.e("default-libs_purchasing_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @envytory-micro-apps/purchasing */ 72180))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.5652",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@envytory-micro-apps/purchasing",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		69852
	],
	"default-webpack_sharing_consume_default_angular_common_angular_common": [
		48310
	],
	"default-webpack_sharing_consume_default_rxjs_rxjs": [
		13258
	],
	"default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators": [
		28822
	],
	"node_modules_angular_core_fesm2022_core_mjs": [
		81170,
		92232
	],
	"default-webpack_sharing_consume_default_angular_common_http_angular_common_http": [
		37602
	],
	"default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser": [
		56207
	],
	"default-webpack_sharing_consume_default_angular_router_angular_router": [
		72290
	],
	"default-webpack_sharing_consume_default_angular_forms_angular_forms": [
		30908
	],
	"default-webpack_sharing_consume_default_sweetalert2_sweetalert2": [
		72701
	],
	"default-webpack_sharing_consume_default_ngx-toastr_ngx-toastr-webpack_sharing_consume_default-c82c08": [
		44502,
		77515
	],
	"default-webpack_sharing_consume_default_envytory-micro-apps_data-access_envytory-micro-apps_d-7c2c1b": [
		42406,
		89840,
		80672
	],
	"default-webpack_sharing_consume_default_html2canvas_html2canvas": [
		80
	],
	"default-webpack_sharing_consume_default_envytory-micro-apps_shared_common_envytory-micro-apps-4f495e": [
		34016
	],
	"default-libs_purchasing_src_index_ts": [
		59275,
		18435,
		13948
	],
	"default-webpack_sharing_consume_default_angular_animations_angular_animations": [
		34824
	],
	"default-webpack_sharing_consume_default_fortawesome_free-solid-svg-icons_fortawesome_free-sol-ab539f": [
		97324,
		83079
	],
	"default-webpack_sharing_consume_default_ngx-loading-bar_core_ngx-loading-bar_core": [
		79927
	],
	"default-webpack_sharing_consume_default_lodash_lodash": [
		97250
	],
	"default-webpack_sharing_consume_default_dayjs_dayjs": [
		44803
	],
	"default-libs_shared_common_src_index_ts": [
		12254,
		574,
		60517,
		22230,
		51186,
		13231,
		46676,
		74714,
		26537,
		74027,
		1743,
		37789,
		10834,
		7026,
		8324,
		51453,
		3305,
		28634,
		36194,
		56599,
		18920,
		71530,
		61369,
		42369
	],
	"default-node_modules_ng-bootstrap_ng-bootstrap_fesm2022_ng-bootstrap_mjs": [
		88724
	],
	"default-webpack_sharing_consume_default_ag-grid-community_ag-grid-community": [
		11202
	],
	"default-node_modules_ngx-quill_fesm2020_ngx-quill_mjs": [
		12467
	],
	"default-webpack_sharing_consume_default_envytory-micro-apps_purchasing_envytory-micro-apps_pu-a3e134": [
		48558
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}